import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { Client } from "urql";
import { getAthenaIShopChainsQuery } from "../hooks/gqlHooks";

interface DataState {
  data: any[] | null;
  loading: boolean;
  initialized: boolean;
  fetchData: (urqlClient: Client) => Promise<void>;
  init: (urqlClient: Client) => void;
}

/**
 * AthenaからIShopChain情報を取得・保存するストア
 * @note ブラウザタブクローズで初期化される
 */
export const useIShopChainsStore = create<DataState>()(
  persist(
    (set, get) => ({
      data: null,
      loading: false,
      initialized: false,
      fetchData: async (urqlClient: Client) => {
        if (get().data) return; // すでに取得済みなら再フェッチしない

        set({ loading: true });
        try {
          const { data, error } = await urqlClient.query(getAthenaIShopChainsQuery, {}).toPromise();
          if (error) {
            console.error("fetching IShopChains failed:", error);
            set({ loading: false });
            return;
          }
          set({ data: data.getAthenaIShopChains, loading: false, initialized: true });
        } catch (e) {
          console.error("fetchData failed:", e);
          set({ loading: false });
        }
      },
      init: (urqlClient: Client) => {
        if (get().initialized) return;
        get().fetchData(urqlClient);
      },
    }),
    {
      name: "athena-ishop-chains", // ストレージキー
      storage: createJSONStorage(() => sessionStorage), // sessionStorageを利用
    }
  )
);
